import Translation from '../lang/Translation';
import {getSelectedDeliveryOptionIDList} from '../selectors/DeliveryOptionsSelectors/DeliveryOptionsSelectors';
import getDeliveryAddress from '../selectors/PlaceOrderSelectors/getDeliveryAddress';
import {getSettings} from '../selectors/selectors';
import Track from '../utils/tracking';
import {setPageMessage} from './pageMessageActions';

export default (dispatch, getState) => {
  try {
    if (getState().address && getDeliveryAddress(getState())
      && getSelectedDeliveryOptionIDList(getState())?.length
      && getSettings(getState())?.collection_delivery_id_list?.length) {
      let mismatch = false;
      let error = '';
      const placeOrderAddress = getDeliveryAddress(getState());
      const deliveryIdList = getSelectedDeliveryOptionIDList(getState());
      const collectionIdList = getSettings(getState())?.collection_delivery_id_list;
      
      if (placeOrderAddress?.addressType === 'click-and-collect') {
        deliveryIdList.forEach((id) => {
          if (!collectionIdList?.includes(id)) {
            mismatch = true;
            error = 'click.and.collect.mismatch.error';
            Track.error(`Delivery address mismatch type collection with id: ${id}`);
          }
        });
      } else {
        deliveryIdList.forEach((id) => {
          if (collectionIdList?.includes(id)) {
            mismatch = true;
            error = 'delivery.mismatch.error';
            Track.error(`Delivery address mismatch type postal with id: ${id}`);
          }
        });
      }
      
      if (mismatch && error) {
        dispatch(setPageMessage(Translation.getText(error)));
        return true;
      }
    }
    
    return false;
  } catch (e) {
    Track.error(`Error preventing delivery mismatch with error: ${e}`);
  }
};
